import { Component, input, output } from '@angular/core';

import { Subject } from 'rxjs';

import { CamAbstractInput } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import { LayoutContentComponent, LayoutPanelComponent, LayoutWithPanelComponent, LinkComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { FiltersFormComponent } from '../form/filters-form.component';
import { FiltersTagComponent } from '../tag/filters-tag.component';
import { ActiveFilterTag } from '../types';

@Component({
  selector: 'cam-filters-container',
  templateUrl: './filters-container.component.html',
  styleUrls: ['./filters-container.component.scss'],
  imports: [
    FontIconComponent,
    LayoutContentComponent,
    LayoutPanelComponent,
    LayoutWithPanelComponent,
    LinkComponent,
    FiltersTagComponent,
    FiltersFormComponent,
  ],
})
export class FiltersContainerComponent extends CamBaseComponent {
  form = input<CamAbstractInput[]>([]);

  activeFilter = input<ActiveFilterTag[]>([]);

  filtersSelected = output<any>();

  removedFilter = output<ActiveFilterTag>();

  public isFilterOpen = false;
  public askValidation$ = new Subject<null>();

  public toggleFilter() {
    if (this.isFilterOpen) {
      this.askValidation$.next(null);
    }
    this.isFilterOpen = !this.isFilterOpen;
  }

  public apply(data: any) {
    this.filtersSelected.emit(data);
  }
}
